import { format, parseISO } from 'date-fns';
import { it } from 'date-fns/locale';

export function formatDataCompleta(dataISO: string): string {
  return format(parseISO(dataISO), 'EEEE d MMMM yyyy', { locale: it });
}

export function formatMeseAnno(dataISO: string): string {
  return format(parseISO(dataISO), 'MMMM yyyy', { locale: it });
}

export function formatDataBreve(dataISO: string): string {
  return format(parseISO(dataISO), 'd MMMM yyyy', { locale: it });
}
